import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import React from "react";
import Modal from "react-modal";
import { UpgradePlan } from "../../components/modals/upgrade/upgradePlan";
import { InjectedUiStore } from "../../models/ui";
import { IUiStore } from "../../models/ui/UiStore";
import styles from "./modalContainer.css";

interface Props {
  uiStore?: IUiStore;
}

@inject("uiStore")
@observer
export class ModalContainer extends React.Component<Props> {
  @observable isOpen = true;

  get injected(): InjectedUiStore {
    return this.props as InjectedUiStore;
  }

  componentWillMount() {
    Modal.setAppElement("#app");
  }

  closeModal = () => {
    this.isOpen = false;
    this.props.uiStore!.changeUpgrade();
  };

  render() {
    return (
      <Modal
        isOpen={this.isOpen}
        shouldCloseOnEsc
        className={styles.container}
        overlayClassName={styles.overlay}
        onRequestClose={this.closeModal}
        shouldCloseOnOverlayClick
      >
        <UpgradePlan closeModal={this.closeModal} />
        <button className={styles["close-button"]} onClick={this.closeModal}>
          <i className="icon-close-cross" />
        </button>
      </Modal>
    );
  }
}
